import { IconType } from 'react-icons';

import { Button, ButtonProps } from '@/components/Button';
import { clsx } from '@/utils/helpers';

export type MenuItemButtonProps = ButtonProps & {
  isActive?: boolean;
  icon: IconType;
  label: string;
};

export function MenuItemButton({
  isActive = false,
  icon: Icon,
  label,
  ...props
}: MenuItemButtonProps) {
  return (
    <Button
      className="flex h-auto flex-col items-center gap-1 p-0"
      variant="ghost"
      {...props}
    >
      <span
        className={clsx(
          'flex items-center justify-center',
          'size-8 p-1.5 shadow-inner',
          'rounded-md bg-gray-100',
          isActive && 'bg-zmyle-primary',
        )}
      >
        <Icon className="size-5 fill-white" />
      </span>

      <span className="text-xs font-bold">{label}</span>
    </Button>
  );
}
